import React, { useEffect, useState } from 'react'
import { myFirestore } from '../../config/MyFirebase';
import { collection, query, where, DocumentData, getDocs, onSnapshot } from 'firebase/firestore';
import { doc, getDoc, setDoc, updateDoc, Timestamp } from "firebase/firestore";

import { getStorage, ref, uploadBytesResumable, getDownloadURL, UploadTask } from "firebase/storage";

import image from '../layouts/assets/img/prod-3.jpg';

import { useAppSelector, useAppDispatch } from '../../config/hooks'

import { decrement, increment } from '../../config/counterSlice'
import { setUser } from '../../config/userSlice'


import { useFormik } from 'formik';
import * as Yup from 'yup';
import { format } from 'date-fns';

const { v4: uuidv4 } = require('uuid');

enum messagesTypes {
    text = "text",
    image = "image",
    video = "video",
    file = "file",
    audio = "audio",
}

const Result = ({ status, progress }: { status: string, progress: number }) => {
    if (status === "initial") {
        return <p></p>;
    } else if (status === "success") {
        return <p>✅ File uploaded successfully!</p>;
    } else if (status === "fail") {
        return <p>❌ File upload failed!</p>;
    } else if (status === "uploading") {
        return <p>⏳ Uploading selected file <b>{progress.toFixed(2)}%</b></p>;
    } else if (status === "pause") {
        return <p>⏳ Uploading file paused...</p>;
    } else {
        return null;
    }
};

export default function Home({ messages, activeDateMessage, userId }: { messages: any[], activeDateMessage: string, userId: string }) {

    // var uploadTask: UploadTask | null = null;
    const storage = getStorage();

    const [progressPercent, setProgressPercent] = useState<number>(0);
    const [uploadTask, setUploadTask] = useState<any | null>(null);
    const [file, setFile] = useState<File | null>(null);
    const [status, setStatus] = useState<
        "initial" | "uploading" | "pause" | "success" | "fail"
    >("initial");



    // The `state` arg is correctly typed as `RootState` already
    const count = useAppSelector((state) => state.counter.value);
    const user = useAppSelector((state) => state.user.user);
    const dispatch = useAppDispatch();


    const [listUser, setListUser] = useState<String[]>([]);

    const [showCopySuccess, setShowCopySuccess] = useState(false);
    const [copySuccess, setCopySuccess] = useState('');



    const formik = useFormik({
        initialValues: {
            message: '',
        },
        validationSchema: Yup.object({

            message: Yup.string().required('Enter a message'),

        }),
        onSubmit: values => {
            // alert(JSON.stringify(values, null, 2));
            console.log(values);
            sendMessage(values.message);
            formik.values.message = '';
        },
    });

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setStatus("initial");
            setFile(e.target.files[0]);

            // Create the file metadata
            // /** @type {any} */
            // const metadata = {
            //     contentType: 'image/jpeg'
            // };

            // Upload file and metadata to the object 'images/mountains.jpg'
            const storageRef = ref(storage, 'files/' + e.target.files[0].name);
            setUploadTask(uploadBytesResumable(storageRef, e.target.files[0]));

        }
    };
    const clearFileSelect = () => {
        if (uploadTask != null) {

            console.log("uploading task and non null")
            uploadTask.pause();
            uploadTask.cancel();
            setUploadTask(uploadTask.pause());
            setUploadTask(uploadTask.cancel());
            setUploadTask(uploadTask.cancel());
            setUploadTask(uploadTask.cancel());
            setUploadTask(null);
        } else {
            console.log("not cancel uploading");
        }
        setFile(null);
        setUploadTask(null);
    };

    const cancelUploadingFile = async () => {

        if (status == "uploading" && uploadTask != null) {
            uploadTask.cancel();

        }
    }

    const handleUpload = async () => {
        if (file) {


            // Create the file metadata
            // /** @type {any} */
            // const metadata = {
            //     contentType: 'image/jpeg'
            // };

            // Upload file and metadata to the object 'images/mountains.jpg'
            const storageRef = ref(storage, 'files/' + file.name);
            setUploadTask(uploadBytesResumable(storageRef, file));

            // Listen for state changes, errors, and completion of the upload.
            if (uploadTask != null) {
                setStatus("uploading");

                console.log("uploadTask != null");
                uploadTask.on('state_changed',
                    (snapshot: any) => {
                        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        setProgressPercent(progress);
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case 'paused':
                                setStatus("pause");

                                console.log('Upload is paused');
                                break;

                            case 'running':
                                setStatus("uploading");
                                console.log('Upload is running');
                                break;
                        }
                    },
                    (error: any) => {
                        // A full list of error codes is available at
                        // https://firebase.google.com/docs/storage/web/handle-errors
                        switch (error.code) {
                            case 'storage/unauthorized':
                                // User doesn't have permission to access the object
                                setStatus("fail");

                                break;
                            case 'storage/canceled':
                                // User canceled the upload
                                setStatus("fail");
                                break;

                            // ...

                            case 'storage/unknown':
                                // Unknown error occurred, inspect error.serverResponse
                                setStatus("pause");

                                break;
                        }
                    },
                    () => {
                        // Upload completed successfully, now we can get the download URL
                        if (uploadTask != null) {

                            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                                console.log('File available at', downloadURL);
                                sendFileMessage(downloadURL, file.name);
                                setStatus("initial");
                                setFile(null);
                                setProgressPercent(0);
                                setUploadTask(null);
                            });
                        }
                    }
                );
            } else {
                console.log("uploadTask == null");

            }


        }
    };

    const generateRandomId = (length: number, chaine: string) => {
        let result = '';

        for (let i = 0; i < length; i++) {
            result += chaine.charAt(Math.floor(Math.random() * chaine.length));
        }

        return result;
    };

    const sendMessage = async (message: string) => {

        //check if dateMessage for today exist
        let today = format(new Date(), "M/d/yyyy");
        // Create a query against the collection.
        const dateMessagesQuery = collection(myFirestore, "users", userId, "date_messages");
        const q = query(dateMessagesQuery, where("date", "==", today));

        const querySnapshot = await getDocs(q);

        let date_message_id = '';
        let date_count_messages = 0;
        console.log("send message");
        if (querySnapshot.size > 0) {
            //If date_message_id already exist
            //If the date_messages for today already exist
            //Return her id
            console.log("date message exist");

            querySnapshot.forEach((doc) => {
                date_message_id = doc.id;
                // console.log("date message exist data: ", doc.get('count_messages'));

                date_count_messages = parseInt(doc.get('count_messages'));
            });


        } else {
            console.log("date message don't exist");

            //if date_message_id not already exist
            let new_id_date_message = uuidv4();
            // let new_id_date_message = generateRandomId(10, uuidv4());
            let now = Timestamp.fromDate(new Date());
            let formattedNow = format(today, "M/d/yyyy");

            // Add a new document in collection "date_messages"
            await setDoc(doc(myFirestore, "users", userId, "date_messages", new_id_date_message), {
                "id": new_id_date_message,
                "date": formattedNow,
                "last_message_time": Timestamp.now(),
                "last_message_type": messagesTypes.text,
                "last_message": "",
                "count_messages": 0,
                "user_id": userId,
                "timestamps": now,
            }).then(() => date_message_id = new_id_date_message);

        }

        if (date_message_id != '') {

            let new_id_message = uuidv4();
            // let new_id_message = generateRandomId(10, uuidv4());

            let formattedDateNow = format(new Date(), "M/d/yyyy");
            let formattedTimeNow = format(new Date(), "h:mm a");
            console.log(formattedTimeNow);
            let messageDuration = 15; //15 minutes par défaut

            let type = messagesTypes.text;
            let now = Timestamp.now();


            //After get the date_message_id insert the message
            await setDoc(doc(myFirestore, "users", userId, "date_messages", date_message_id, "messages", new_id_message), {
                "id": new_id_message,
                "type": type,
                "content": message,
                "filename": "",
                "file_url": "",
                "date": formattedDateNow,
                "time": formattedTimeNow,
                "url": "",
                "user_id": userId,
                "date_message_id": date_message_id,
                "timestamps": now,
            }).then(async () => {

                console.log("message created");

                //Then update the date_message informations
                await updateDoc(doc(myFirestore, "users", userId, "date_messages", date_message_id), {
                    "last_message_time": now,
                    "last_message_type": type,
                    "last_message": message,
                    "count_messages": date_count_messages + 1,
                });

            });

        }


    }

    const sendFileMessage = async (fileUrl: string, fileName: string) => {

        //check if dateMessage for today exist
        let today = format(new Date(), "M/d/yyyy");
        // Create a query against the collection.
        const dateMessagesQuery = collection(myFirestore, "users", userId, "date_messages");
        const q = query(dateMessagesQuery, where("date", "==", today));

        const querySnapshot = await getDocs(q);

        let date_message_id = '';
        let date_count_messages = 0;

        if (querySnapshot.size > 0) {
            //If date_message_id already exist
            //If the date_messages for today already exist
            //Return her id
            querySnapshot.forEach((doc) => {
                date_message_id = doc.id;
                date_count_messages = parseInt(doc.get('count_messages'));

            });


        } else {
            //if date_message_id not already exist
            let new_id_date_message = uuidv4();
            // let new_id_date_message = generateRandomId(10, uuidv4());
            let now = Timestamp.fromDate(new Date());
            let formattedNow = format(today, "M/d/yyyy");

            // Add a new document in collection "date_messages"
            await setDoc(doc(myFirestore, "users", userId, "date_messages", new_id_date_message), {
                "id": new_id_date_message,
                "date": formattedNow,
                "last_message_time": Timestamp.now(),
                "last_message_type": messagesTypes.text,
                "last_message": "",
                "count_messages": 0,
                "user_id": userId,
                "timestamps": now,
            }).then(() => date_message_id = new_id_date_message);

        }

        if (date_message_id != '') {

            let new_id_message = uuidv4();
            // let new_id_message = generateRandomId(10, uuidv4());

            let formattedDateNow = format(new Date(), "M/d/yyyy");
            let formattedTimeNow = format(new Date(), "h:mm a");
            console.log(formattedTimeNow);
            let messageDuration = 15; //15 minutes par défaut

            let type = messagesTypes.file; //0: messagetext 1: image 2: video 3:autre
            let now = Timestamp.now();


            //After get the date_message_id insert the message
            await setDoc(doc(myFirestore, "users", userId, "date_messages", date_message_id, "messages", new_id_message), {

                "id": new_id_message,
                "type": type,
                "content": "",
                "filename": fileName,
                "file_url": fileUrl,
                "date": formattedDateNow,
                "time": formattedTimeNow,
                "url": "",
                "user_id": userId,
                "date_message_id": date_message_id,
                "timestamps": now,

            }).then(async () => {

                console.log("message created");

                //Then update the date_message informations
                await updateDoc(doc(myFirestore, "users", userId, "date_messages", date_message_id), {
                    "last_message_time": now,
                    "last_message_type": type,
                    "last_message": "",
                    "count_messages": date_count_messages + 1,
                });

            });

        }


    }

    // function to copy here
    const copyToClipBoard = async (copyMe: string) => {
        try {
            await navigator.clipboard.writeText(copyMe);
            setShowCopySuccess(true);
            setCopySuccess('Message copied!');
            setTimeout(() => {
                setCopySuccess('');
                setShowCopySuccess(false);

            }, 3000);

        } catch (err) {
            setCopySuccess('Failed to copy!');
        }
        // const img = await fetch(image);
        // const imgBlob = await img.blob();
        // try {
        //     navigator.clipboard.write([
        //         new ClipboardItem({
        //             'image/png': imgBlob, // change image type accordingly
        //         })
        //     ]);
        // } catch (error) {
        //     console.error(error);
        // }
    };

    // Get a list of cities from your database
    const getListUser = async () => {
        //console.log("Lancement de la récupération")
        //FIRESTORE SIMPLE AVEC LITE
        // const citiesCol = collection(myFirestore, 'chatrooms');
        // const citySnapshot = await getDocs(citiesCol);
        // const cityList = citySnapshot.docs.map(doc => doc.data());

        // setListUser(cityList);
        // // console.log(cityList);
        // cityList.map((data) => console.log(data.users["1"]));

        //////////////////////////////////////////////////////////
        //FIRESTORE SIMPLE AVEC FIRESTORE MEME

        // const querySnapshot = await getDocs(collection(myFirestore, "chatrooms"));

        // querySnapshot.forEach((doc) => {
        //     console.log(doc.data());
        // });
        ///////////////////////////////////////


        //FIRESTORE MISES A JOUR EN TEMPS REEL
        // const q = query(collection(myFirestore, "chatrooms",));
        // const unsubscribe = onSnapshot(q, (querySnapshot) => {
        //     let cities: String[] = [];
        //     querySnapshot.forEach((doc) => {
        //         cities.push(doc.data().users["0"] + doc.data().users["1"]);
        //     });
        //     setListUser(cities);
        //     console.log("Datas: ", cities.join(", "));
        // });


        //FIRESTORE REQUETE SIMPLE SOUS COLLECTION pour récupérer les messages
        // const querySnapshot = await getDocs(collection(myFirestore, "chatrooms", "ALIBONGO_OUMARSAVI.COM", "chats"));

        // const messages: String[] = [];

        // querySnapshot.forEach((doc) => {
        //     messages.push(doc.data().message)
        //     console.log(doc.id, " => ", doc.data());
        // });
        // setListUser(messages);


        //FIRESTORE MISES A JOUR EN TEMPS REEL pour récupérer les sous collections de message
        const q = query(collection(myFirestore, "users", "XsuTdSpsYhU6ARhv98rbB49siQJ2", "date_messages", "YFXS70PUTp", "messages"));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            let messages: String[] = [];
            querySnapshot.forEach((doc) => {
                messages.push(doc.data().content);
            });
            setListUser(messages);
        });


    }

    useEffect(() => {
        //getListUser();
        console.log("user timestamp is", user.timestamps);
        console.log("user date_expiration sub is", user.date_expiration_subscription);
        console.log("user date sub is", user.date_subscription.toDate());
    }, [uploadTask]);




    const loadMessages =

        messages && messages.length > 0 ?   //if we have minimum one message, provides messages

            messages.map((message) => {


                const type = message.type;

                const content = () => {


                    if (message.type === messagesTypes.text) {

                        return (<div className=" direct-chat-text">


                            {message.content}
                        </div>);
                    } else if (message.type === messagesTypes.image || message.type === messagesTypes.video || message.type === messagesTypes.file || message.type === messagesTypes.audio) {
                        return (<div className=" direct-chat-text cp-file-message row">
                            {/* <img style={{ width: '100%', objectFit: 'contain', }} src={message.image_url} alt="Attachment" /> */}
                            <div className='col-9'>
                                <p>{message.filename}</p>
                            </div>
                            {/* <div className='col-3'>
                                <i className='fas fa-file' ></i>
                            </div> */}

                        </div>);

                    }
                }

                const actionButton = () => {


                    if (message.type === messagesTypes.text) {

                        return (<div className='float-right'>
                            <div style={{}} onClick={() => copyToClipBoard(message.content)} className="cp-copy-btn d-inline-block direct-chat-timestamp mr-3">
                                Copy
                                <i className='ml-1 fas fa-copy' ></i>
                            </div>
                            <div className="d-inline-block direct-chat-timestamp">{message.time}</div>

                        </div>);

                    } else if (message.type === messagesTypes.image || message.type === messagesTypes.video || message.type === messagesTypes.file || message.type === messagesTypes.audio) {
                        return (<div className='float-right'>
                            <div style={{}} onClick={() => copyToClipBoard(message.content)} className="d-inline-block direct-chat-timestamp mr-3">
                                <a style={{}} className="cp-download-btn" href={message.file_url}>
                                    Download
                                    <i className='ml-1 fas fa-download' ></i>
                                </a>
                            </div>
                            <div className="d-inline-block direct-chat-timestamp">{message.time}</div>

                        </div>);

                    }
                }


                return (

                    <div key={uuidv4()} className="direct-chat-msg right col-4 offset-md-8 mb-3">
                        {/* <img className="direct-chat-img" src="dist/img/user3-128x128.jpg" alt="message user image" /> */}
                        {content()}
                        <div style={{ marginRight: '50px', }} className="direct-chat-infos clearfix">
                            {/* <span className="direct-chat-name float-right">Sarah Bullock</span> */}
                            {actionButton()}
                        </div>
                    </div>

                    // <div key={uuidv4()} className="direct-chat-msg right">
                    //     {/* <img className="direct-chat-img" src="dist/img/user1-128x128.jpg" alt="message user image" /> */}
                    //     <div className="direct-chat-text">
                    //         {content()}
                    //     </div>
                    //     <div className="direct-chat-infos clearfix">
                    //         {/* <span className="direct-chat-name float-left">Alexander Pierce</span> */}
                    //         {actionButton()}
                    //     </div>
                    // </div >
                )

            })

            : <div className="alert alert-secondary">
                YOU DON'T HAVE MESSAGES AT THIS DATE

            </div> //Else we don't have any message we provide 0 message


    return (

        <div className="content-wrapper">

            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{activeDateMessage}</h1>
                        </div>
                        {/* <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="#">Home</a></li>
                                <li className="breadcrumb-item active">Dashboard v1</li>
                            </ol>
                        </div> */}
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">

                    <div className="row">
                        <section className="col-lg-12 connectedSortable">


                            <div className="card direct-chat direct-chat-primary">

                                {
                                    showCopySuccess ? (<div className="card-header">
                                        {/* <h3 className="card-title">Direct Chat</h3> */}

                                        <div className="card-tools">
                                            {/* <span title="3 New Messages" className="badge badge-primary">3</span>
                                        <button type="button" className="btn btn-tool" data-card-widget="collapse">
                                            <i className="fas fa-minus"></i>
                                        </button> */}
                                            <b>{copySuccess}</b>
                                            {/* <button type="button" className="btn btn-tool" title="Contacts" data-widget="chat-pane-toggle">
                                            <i className="fas fa-comments"></i>
                                        </button> */}
                                            {/* <button type="button" className="btn btn-tool" data-card-widget="remove">
                                            <i className="fas fa-times"></i>
                                        </button> */}
                                        </div>
                                    </div>) : null
                                }

                                <div className="card-body">
                                    <div className="direct-chat-messages">


                                        {loadMessages}


                                        {/* <div className="direct-chat-msg right">
                                            <div className="direct-chat-infos clearfix">
                                                <span className="direct-chat-name float-right">Sarah Bullock</span>
                                                <span className="direct-chat-timestamp float-left">23 Jan 2:05 pm</span>
                                            </div>
                                            <img className="direct-chat-img" src="dist/img/user3-128x128.jpg" alt="message user image" />
                                            <div className="direct-chat-text">
                                                You better believe it!
                                            </div>
                                        </div> */}

                                        {/* <div className="direct-chat-msg">
                                            <div className="direct-chat-infos clearfix">
                                                <span className="direct-chat-name float-left">Alexander Pierce</span>
                                                <span className="direct-chat-timestamp float-right">23 Jan 5:37 pm</span>
                                            </div>
                                            <img className="direct-chat-img" src="dist/img/user1-128x128.jpg" alt="message user image" />
                                            <div className="direct-chat-text">
                                                Working with AdminLTE on a great new app! Wanna join?
                                            </div>
                                        </div> */}



                                    </div>

                                </div>
                                <div className="card-footer">

                                    <Result status={status} progress={progressPercent} />

                                    <div className="row">
                                        <div className={file ? "col-10" : "col-2"}>

                                            <form encType="mulpart/form-data">
                                                <div className="input-group">
                                                    {
                                                        file ?
                                                            (<div className=''>
                                                                {
                                                                    status == "initial" ?
                                                                        <button className='btn d-inline' onClick={clearFileSelect}> <i className='fas fa-times-circle' ></i></button>
                                                                        : null
                                                                }
                                                                <p className=' d-inline'>{file.name} - {file.type} - {file.size} </p>
                                                            </div>
                                                            )
                                                            :
                                                            <input id="file" className='visually-hidden btn btn-sm btn-primary' type="file" name='file' onChange={handleFileChange} />
                                                    }


                                                </div>
                                            </form>
                                        </div>
                                        <div className={file ? "right" : "col-10"}>

                                            {
                                                (file && status == "initial") ?
                                                    <button className='btn btn-primary' onClick={handleUpload}>Send file</button>
                                                    :

                                                    null
                                            }


                                            {
                                                (file) ?
                                                    null
                                                    :

                                                    <form onSubmit={formik.handleSubmit}>

                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                name="message"
                                                                placeholder="Type Message ..."
                                                                id="email"
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                value={formik.values.message}
                                                                className={formik.touched.message && formik.errors.message ? ('form-control is-invalid') : "form-control"}
                                                            />
                                                            <span className="input-group-append">
                                                                <button type="submit" className="btn btn-primary">Send</button>
                                                            </span>
                                                            {formik.touched.message && formik.errors.message ? (
                                                                <div id="" className="error invalid-feedback">{formik.errors.message}</div>
                                                            ) : null}
                                                        </div>
                                                    </form>}

                                        </div>
                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    )
}
